
import useBookingCalendar from "@/composables/useBookingCalendar";
import useDayTrip from "@/composables/useDayTrip";
import { EEEddMMMyyyy, today, YYYYMMDD } from "@/helpers/dateHelper";
import { DirectionEnum } from "@/models/enums";
import { useBookingStore } from "@/store/booking";
import "swiper/swiper-bundle.css";
import SwiperCore, { A11y, Navigation, Virtual } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue/swiper-vue";
import { computed, defineComponent, PropType } from "vue";

SwiperCore.use([Navigation, A11y, Virtual]);

export default defineComponent({
	components: {
		Swiper,
		SwiperSlide,
	},
	props: {
		direction: {
			type: Number as PropType<DirectionEnum>,
			required: true,
		},
	},
	setup(props) {
		const { setDate, getDate, getBooking } = useBookingStore();
		const { getAvailableDates, getNextAvailableDate } = useBookingCalendar();
		const { isDayTrip, openDayTripDialog } = useDayTrip();

		const availableDates = computed(() => {
			if(!getBooking.amendmentMode) {
				const startOfToday = today();
				return getAvailableDates(props.direction).filter(d => d.start >= startOfToday);
			}
			
			return getAvailableDates(props.direction);
		});

		const initialSlide = computed(() => {
			const index = availableDates.value.findIndex((v) => {
				return EEEddMMMyyyy(v.start) === date.value;
			});

			return index;
		});

		const date = computed({
			get(): string | undefined {
				const date = getDate(props.direction);
				return date ? EEEddMMMyyyy(date) : undefined;
			},
			set(value: string | undefined) {
				//check for daytrip selection
				//if daytrip is selected and the customer
				//then selects a later date in departures than
				//outward date then trigger dialog
				if (props.direction === DirectionEnum.Return) {
					if (
						isDayTrip.value &&
						(value ?? new Date()) >
							YYYYMMDD(getDate(props.direction) ?? new Date())
					) {
						openDayTripDialog(value);
					} else {
						setDate(props.direction, value ? new Date(value) : undefined);
					}
				} else {
					setDate(props.direction, value ? new Date(value) : undefined);
				}

				if (props.direction === DirectionEnum.Outward && value) {
					const returnDate = getDate(DirectionEnum.Return);
					//If the date set is after the return date, set it to the next available date
					if (
						typeof returnDate !== "undefined" &&
						returnDate < new Date(value)
					) {
						const nextAvailableDate = getNextAvailableDate(
							DirectionEnum.Return
						);
						if (nextAvailableDate) {
							setDate(DirectionEnum.Return, nextAvailableDate.start);
						}
					}
				}
			},
		});

		const breakpoints = {
			0: { slidesPerView: 1 },
			600: { slidesPerView: 3 },
		};

		return {
			DirectionEnum,
			availableDates,
			date,
			YYYYMMDD,
			initialSlide,
			breakpoints,
			EEEddMMMyyyy,
		};
	},
});
